// hooks/usePageTitle.js - Set document title per page
import { useEffect } from 'react';

export default function usePageTitle(title) {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title} | AdaptIQ` : 'AdaptIQ';
    return () => { document.title = prev; };
  }, [title]);
}
